import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedReleaseNotes,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPages } from '../../components/PublishedPages';

export const PublishedReleaseNotes = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Release Notes'
      }
    ]);
  }, []);
  return <PublishedPages {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPages: state.getIn([NS, 'publishedReleaseNotes']),
  pending: state.getIn([NS, 'pending', 'publishedReleaseNotes']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPages: serviceHandle =>
    dispatch(getPublishedReleaseNotes(serviceHandle)),
  updateCrumbs: payload => dispatch(updateCrumbs(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedReleaseNotes);
